<script>
    import { locale, _ } from 'svelte-i18n'
</script>

<div class="pt-5">
    <div class="bg-black">
        <section class="mobile-payment-section rounded-bottom-3 text-white spaced-light rounded shadow">
            <article class="dark-background-overlay h-100 py-5 px-4 px-sm-5 rounded">
                <h1 class="h5 mb-4">{$_('page.about.section_1.h')}</h1>

                <p class="fs-6 mb-5">
                    {$_('page.about.section_1.p_1')}
                </p>

                <p class="fs-6 mb-5 visually-hidden">
                    {$_('page.about.section_1.p_2')}
                </p>

                <p class="fs-6 mb-5 visually-hidden">
                    {$_('page.about.section_1.p_3')}
                </p>

                <a href={`/${$locale}/about`} class="btn btn-success px-5 spaced-light shadow fs-5"
                    >{$_('page.about.read_more')}</a
                >
            </article>
        </section>
    </div>
</div>
